export const fallbackLng = 'ar';
export const languages = [fallbackLng, 'en'];
export const defaultNS = 'common';
export const cookieName = 'i18next';
export const headerName = 'x-i18next-current-language';
